var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7104 11.9011C19.0019 15.4437 16.3308 18.7793 12.5828 19.5246C10.7549 19.8887 8.85867 19.6667 7.1642 18.8904C5.46972 18.114 4.06338 16.8229 3.1454 15.2008C2.22743 13.5787 1.84462 11.7083 2.05149 9.85593C2.25837 8.0036 3.04437 6.26375 4.29758 4.88411C6.86804 2.05293 11.2083 1.27357 14.7509 2.69058",
    stroke: "#8F5726",
    strokeWidth: 2.12551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.66584 10.4842L11.2084 14.0267L19.7104 4.81616",
    stroke: "#8F5726",
    strokeWidth: 2.12551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSvg);
export default __webpack_public_path__ + "static/media/about-svg.cb425f3db096a3a0a62d926b76d4cee1.svg";
export { ForwardRef as ReactComponent };